import { Tooltip } from 'antd';
import { IconButton } from 'icon-button';
import React from 'react';
import { usePlatmapContext } from '@mono/platmap-context';

export const MapControls = () => {
    const { controls } = usePlatmapContext();
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 6 }}>
            {controls.map((control) => {
                const onClick = control.onClick ?? (() => {});
                if (!control.metUiIcon && !control.ReactIcon) return <div />;

                if (control.metUiIcon) {
                    return (
                        <div key={control.id} style={{ position: 'relative' }}>
                            <Tooltip title={control.tooltip} placement={'left'}>
                                <span>
                                    {/* span is needed for tooltip to work */}
                                    <IconButton darkTheme metuiIcon={control.metUiIcon} onClick={onClick} />
                                </span>
                            </Tooltip>
                        </div>
                    );
                }

                return (
                    <div key={control.id} style={{ position: 'relative' }}>
                        <Tooltip title='Reset view' placement={'left'}>
                            <span>
                                {/* span is needed for tooltip to work */}
                                <IconButton darkTheme CustomIcon={control.ReactIcon} onClick={onClick} />
                            </span>
                        </Tooltip>
                    </div>
                );
            })}
        </div>
    );
};
